import md5 from 'js-md5';

export function deepCopyObjectBtoSource(objA, objB) {
  for (const key in objB) {
    if (typeof objB[key] === 'object' && objB[key] !== null) {
      if (objA.hasOwnProperty(key)) {
        deepCopyObjectBtoSource(objA[key], objB[key]);
      }
    } else if (objA.hasOwnProperty(key)) {
      objA[key] = objB[key];
    }
  }
}

export function getImageInfoByOssUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const fileType = url.split('.').pop()
      fetch(url+'?timestamp=' + Date.now(), {
        method: 'HEAD',
      }).then(response => {
        const fileSize = response.headers.get('Content-Length') / 1024; //以 KB 为单位
        resolve({ width, height, fileType, fileSize });
        }).catch(error => console.error(error));
    };
    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };
    img.src = url;
  });


}

export function getImageInfo(base64) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      const dataURL = canvas.toDataURL();
      const match = dataURL.match(/^data:(.*);base64,(.*)$/);
      if (!match) {
        reject(new Error('Invalid image data URL'));
        return;
      }
      const fileType = match[1];
      const binaryStr = atob(match[2]);
      const fileSize = new Blob([binaryStr]).size;
      resolve({ width, height, fileType, fileSize });
    };
    img.onerror = () => {
      reject(new Error('Failed to load image'));
    };
    img.src = base64;
  });
}

export function setToken (token) {
  localStorage.setItem('access_token', token)
}

export function delToken () {
  localStorage.removeItem('access_token')
  localStorage.removeItem('userInfo')
  sessionStorage.removeItem('access_token')
}

export async function calculateFileMd5(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.onload = function (e) {
      const fileData = e.target.result;
      const fileMd5 = md5(fileData);
      resolve(fileMd5);
    };

    fileReader.onerror = function () {
      reject(new Error('Failed to read file'));
    };

    fileReader.readAsBinaryString(file);
  });
}

export function setUserInfo (info) {
  delUserInfo()
  localStorage.setItem('userInfo', JSON.stringify(info))
}

export function getUserInfo () {
  return JSON.parse(localStorage.getItem('userInfo'))
}

export function delUserInfo () {
  localStorage.removeItem('userInfo')
  sessionStorage.removeItem('userInfo')
}
